var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraFrontActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 42,
    viewBox: "0 0 23 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0625 1H4.9375C2.76288 1 1 2.76288 1 4.9375V36.4375C1 38.6121 2.76288 40.375 4.9375 40.375H18.0625C20.2371 40.375 22 38.6121 22 36.4375V4.9375C22 2.76288 20.2371 1 18.0625 1Z",
    stroke: "#077ACC",
    strokeWidth: 1.47656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9375 2H6.90625C7.0803 2 7.24722 2.06914 7.37029 2.19221C7.49336 2.31528 7.5625 2.4822 7.5625 2.65625C7.5625 3.00435 7.70078 3.33819 7.94692 3.58433C8.19306 3.83047 8.5269 3.96875 8.875 3.96875H14.125C14.4731 3.96875 14.8069 3.83047 15.0531 3.58433C15.2992 3.33819 15.4375 3.00435 15.4375 2.65625C15.4375 2.4822 15.5066 2.31528 15.6297 2.19221C15.7528 2.06914 15.9197 2 16.0938 2H18.0625",
    stroke: "#077ACC",
    strokeWidth: 1.47656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraFrontActiveIcon);
export default __webpack_public_path__ + "static/media/cameraFrontActiveIcon.b8405efd9212db4d30f3380fb410d676.svg";
export { ForwardRef as ReactComponent };